export default __webpack_public_path__ + "static/media/plans_image.b74b2026.png";